import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function TraiesteForWho() {
  const forWho = ['Persoane care simt că trăiesc pe pilot automat și că viața trece fără să o trăiască cu adevărat. Vor sens, claritate și prezență reală în fiecare zi.', 'Oameni care își doresc atât succes material cât și împlinire spirituală. Vor ambele, nu doar una sau alta, și vor să înțeleagă cum se îmbină.', 'Persoane care simt că au un potențial mai mare pe care nu îl accesează. Știu că pot mai mult, dar nu au găsit încă cheia care să le deschidă ușa.', 'Oameni interesați de dezvoltare personală și spiritualitate care vor să trăiască mai conștient, să practice recunoștința și să își creeze viața dorită.'];
  const notForWho = ['Persoane care caută soluții rapide, fără implicare. Acest curs cere prezență, practică zilnică și deschidere. Nu e o pastilă magică.', 'Cei care nu cred în conexiunea dintre minte, emoții și realitatea din exterior. Dacă vrei doar tehnici practice fără nicio dimensiune spirituală, nu vei rezona.', 'Oameni care nu sunt dispuși să aplice ceea ce învață. Exercițiile și practicile funcționează doar dacă le faci. Informația fără acțiune nu schimbă nimic.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-2040">
      <div className="max-w-6xl mx-auto px-6" data-id="element-2041">
        <SectionHeading title="Pentru cine este acest curs" data-id="element-2042" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-2043">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-2044">
            <div className="flex items-center gap-4 mb-8" data-id="element-2045">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2046">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-2047" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-2048">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-2049">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-2050">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-2051" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-2052">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-2053">
            <div className="flex items-center gap-4 mb-8" data-id="element-2054">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2055">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-2056" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-2057">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-2058">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-2059">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-2060" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-2061">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2062">
          <CTAButton data-id="element-2063" />
        </motion.div>
      </div>
    </section>;
}